export type ApiErrorInit = {
  status: number;
  code: string;
  message: string;
  requestId: string | undefined;
  body: unknown;
};

/** A non-2xx response. `code` is the backend's error code when it sent one, otherwise `http_<status>`. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly requestId: string | undefined;
  readonly body: unknown;

  constructor({ status, code, message, requestId, body }: ApiErrorInit) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.requestId = requestId;
    this.body = body;
  }
}

export const isApiError = (error: unknown): error is ApiError => error instanceof ApiError;
